// extracted by mini-css-extract-plugin
module.exports = {"editorConfig":"EditorConfig_editorConfig__384qN","instructionsText":"EditorConfig_instructionsText__2pJWz"};